/**
 * Custom hook for managing the "Show Office" preference
 * Used across Jobs page and Analytics to control Office job visibility
 */

import { useState, useCallback } from "react";

const STORAGE_KEY = "show_office_preference";

// Read initial value from localStorage
const getInitialValue = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored === "true";
  } catch (error) {
    console.error("Failed to read show office preference:", error);
    return false;
  }
};

export const useShowOffice = () => {
  const [showOffice, setShowOffice] = useState(getInitialValue);

  const toggleShowOffice = useCallback(() => {
    setShowOffice(current => {
      const newValue = !current;
      try {
        localStorage.setItem(STORAGE_KEY, String(newValue));
      } catch (error) {
        console.error("Failed to save show office preference:", error);
      }
      return newValue;
    });
  }, []);

  const setShowOfficeValue = useCallback((value) => {
    try {
      localStorage.setItem(STORAGE_KEY, String(value));
    } catch (error) {
      console.error("Failed to save show office preference:", error);
    }
    setShowOffice(value);
  }, []);

  return {
    showOffice,
    toggleShowOffice,
    setShowOfficeValue,
  };
};

export default useShowOffice;
